import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";

export default class EBOKWatekKlient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zdjecie:null
        };
    }

    componentDidMount() {
        if(Boolean(this.props.klient)){
            if(this.props.klient.pliki.length>0){
                if(Boolean(this.props.klient.pliki.find(p=>p.dokumentTyp==='KLIENT_ZDJECIE'))){
                    this.setState({
                        zdjecie: (this.props.klient.pliki.find(p=>p.dokumentTyp==='KLIENT_ZDJECIE')).dane
                    })
                }
            }
        }
    }


    render() {

        return (
            <div id={'kartaKlienta'}>
                <div id={'zdjecie'} className={'thumbnail'}>
                    {
                        Boolean(this.state.zdjecie) ?
                            <img src={'data:image/jpg;base64,' + this.state.zdjecie}/>
                            :
                            <div style={{color: 'grey', fontSize: '12px', fontStyle: 'italic', padding:'40px 0', textAlign:'center'}}>Brak zdjęcia</div>

                    }
                </div>
                <div id={'dane'}>
                    <div>
                        <Link to={'/zarzadzanie-klientami/klient/' + this.props.klient.idKl} target={'_blank'}>
                            {this.props.klient.imie + ' ' + this.props.klient.nazwisko}
                        </Link>
                    </div>
                    {Boolean(this.props.klient.pesel) ? <div><i className={'fa fa-id-card-o'}></i> {this.props.klient.pesel}</div> : ''}
                    {Boolean(this.props.klient.nrTel) ? <div><i className={'fa fa-phone'}></i> {this.props.klient.nrTel}</div> : ''}
                    {Boolean(this.props.klient.email) ? <div><i className={'fa fa-envelope-o'}></i> {this.props.klient.email}</div> : ''}
                    <div style={{textAlign: 'center', marginTop: '5px'}}>
                        <Link to={'/zarzadzanie-klientami/klient/' + this.props.klient.idKl} target={'_blank'}>
                            <TopButtonAction iconType={'fa fa-external-link'} text={'Zobacz dane klienta'} btnColor={'default'} btnSize={'xs'}/>
                        </Link>
                    </div>
                </div>
                <div style={{height: '1px', clear: 'both'}}></div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eBOK/componentsWatek/EBOKWatekKlient.js